/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { InjectionToken } from '@angular/core';

export const ActiveCartOrderEntriesContextToken = new InjectionToken(
  'ActiveCartOrderEntriesContext'
);
